<template lang="pug">
  p.changed-icon
    i.icon !
    | Challenge
</template>
<script>
export default {}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .changed-icon
    display flex
    align-items center
    color $primary-color
    text-transform uppercase
    font-weight bold
    font-size 0.7rem

    .icon
      font-size 0.9rem
      margin-right 5px
      color $danger-color
</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengeIcon.vue